var _style, _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgElement84(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Ebene_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 404.5 241",
    style: {
      enableBackground: "new 0 0 404.5 241"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\n\t.st0{fill:none;stroke:#FFFFFF;stroke-miterlimit:10;}\n\t.st1{enable-background:new    ;}\n\t.st2{fill:#FFFFFF;}\n")), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", {
    id: "a"
  }), /*#__PURE__*/React.createElement("g", {
    id: "b"
  }, /*#__PURE__*/React.createElement("g", {
    id: "c"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polyline", {
    className: "st0",
    points: "149.6,240.5 75.1,240.5 0.6,120.5 75.1,0.5 149.6,0.5  "
  }), /*#__PURE__*/React.createElement("g", {
    className: "st1"
  }, /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M77.6,73.2h11.6v3.1h-8v6.5H89v3.1h-7.9v9.5h-3.5V73.2z"
  })), /*#__PURE__*/React.createElement("g", {
    className: "st1"
  }, /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M92.3,79.1h2.9v2.4c0.9-1.9,2.6-2.8,4.9-2.9v3.1h-0.2c-2.9,0-4.5,1.6-4.5,4.9v8.8h-3.1V79.1z"
  })), /*#__PURE__*/React.createElement("g", {
    className: "st1"
  }, /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M103.4,88.2c0.1,3.3,3,5,5.5,5c2.2,0,3.8-1.1,4.7-2.8h3.2c-0.8,1.8-1.9,3.2-3.3,4c-1.4,0.9-3,1.4-4.6,1.4 c-5.3,0-8.6-4.3-8.6-8.6c0-4.7,3.7-8.7,8.6-8.7c2.3,0,4.5,0.9,6,2.4c1.9,2,2.7,4.5,2.5,7.2H103.4z M114.3,85.8 c-0.1-2.2-2.3-4.6-5.4-4.5c-3.2,0-5.2,2.3-5.4,4.5H114.3z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M120.4,73.2h3.1v3.3h-3.1V73.2z M120.4,79.1h3.1v16.3h-3.1V79.1z"
  })), /*#__PURE__*/React.createElement("g", {
    className: "st1"
  }, /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M129.6,88.2c0.1,3.3,3,5,5.5,5c2.2,0,3.8-1.1,4.7-2.8h3.2c-0.8,1.8-1.9,3.2-3.3,4c-1.4,0.9-3,1.4-4.6,1.4 c-5.3,0-8.6-4.3-8.6-8.6c0-4.7,3.7-8.7,8.6-8.7c2.3,0,4.5,0.9,6,2.4c1.9,2,2.7,4.5,2.5,7.2H129.6z M140.5,85.8 c-0.1-2.2-2.3-4.6-5.4-4.5c-3.2,0-5.2,2.3-5.4,4.5H140.5z"
  })), /*#__PURE__*/React.createElement("g", {
    className: "st1"
  }, /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M148,97.7h-2.7l1.9-6.2h3.3L148,97.7z"
  })), /*#__PURE__*/React.createElement("g", {
    className: "st1"
  }, /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M162.4,88.2c0.1,3.3,3,5,5.5,5c2.2,0,3.8-1.1,4.7-2.8h3.2c-0.8,1.8-1.9,3.2-3.3,4c-1.4,0.9-3,1.4-4.6,1.4 c-5.3,0-8.6-4.3-8.6-8.6c0-4.7,3.7-8.7,8.6-8.7c2.3,0,4.5,0.9,6,2.4c1.9,2,2.7,4.5,2.5,7.2H162.4z M173.2,85.8 c-0.1-2.2-2.3-4.6-5.4-4.5c-3.2,0-5.2,2.3-5.4,4.5H173.2z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M179.4,73.2h3.1v3.3h-3.1V73.2z M179.4,79.1h3.1v16.3h-3.1V79.1z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M203.1,93.5c0,2.8-0.7,4.7-1.9,6.1c-1.5,1.7-4,3-6.9,3c-4.6,0-7.3-2.7-8.1-5.4h3.6c0.4,0.7,1,1.4,1.8,1.9 c1,0.7,2.1,0.9,2.8,0.9c2.7,0,5.5-2,5.5-5.7v-1.7c-1,1.8-2.9,3.4-5.9,3.4c-4.9,0-8.4-3.7-8.4-8.6c0-5.1,3.7-8.7,8.4-8.7 c2.7,0,5,1.4,5.9,3.2v-2.8h3.1V93.5z M188.7,87.2c0,3.1,2.2,5.7,5.6,5.7c1.6,0,3-0.6,4-1.7c1-1,1.6-2.4,1.6-4 c0-1.3-0.4-2.8-1.3-3.9c-0.9-1.1-2.3-1.9-4.3-1.9C191.3,81.5,188.7,83.9,188.7,87.2L188.7,87.2z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M209.1,88.2c0.1,3.3,3,5,5.5,5c2.2,0,3.8-1.1,4.7-2.8h3.2c-0.8,1.8-1.9,3.2-3.3,4c-1.4,0.9-3,1.4-4.7,1.4 c-5.3,0-8.6-4.3-8.6-8.6c0-4.7,3.7-8.7,8.6-8.7c2.3,0,4.5,0.9,6,2.4c1.9,2,2.7,4.5,2.5,7.2H209.1z M220,85.8 c-0.2-2.2-2.3-4.6-5.4-4.5c-3.2,0-5.2,2.3-5.4,4.5H220z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M226.1,79.1h2.9v2.5c0.8-1.7,2.6-3,5.5-3c5.2,0.1,6.6,3.8,6.6,7.2v9.6H238v-8.8c0-2.9-1.1-5-4.3-5 c-3.1,0-4.5,2-4.5,4.8v9.1h-3.1V79.1z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M248.7,81.5v13.9h-3.1V81.5h-2.2v-2.4h2.2V78c0-4.9,3.8-5.2,6.1-5.2v2.5c-1,0-3,0-3,2.9v1h7.7v16.3h-3.1 V81.5H248.7z M253.2,76.5v-3.3h3.1v3.3H253.2z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M260.4,79.1h2.9v2.5c0.8-1.7,2.6-3,5.5-3c5.2,0.1,6.6,3.8,6.6,7.2v9.6h-3.2v-8.8c0-2.9-1.1-5-4.3-5 c-3.1,0-4.5,2-4.5,4.8v9.1h-3.1V79.1z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M296.1,95.4H293v-2.8c-1.1,2.2-3.5,3.3-6.1,3.3c-5.2,0-8.4-4.1-8.4-8.6c0-5,3.6-8.6,8.4-8.6 c3.2,0,5.3,1.8,6.1,3.4v-2.9h3.1V95.4z M281.7,87.3c0,2.4,1.7,5.7,5.7,5.7c2.5,0,4.3-1.4,5.1-3.2c0.4-0.8,0.5-1.6,0.6-2.4 s-0.1-1.7-0.5-2.4c-0.8-1.9-2.6-3.4-5.2-3.4C283.9,81.5,281.7,84.2,281.7,87.3L281.7,87.3z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M300.3,79.1h2.9v2.5c0.8-1.7,2.6-3,5.5-3c5.2,0.1,6.6,3.8,6.6,7.2v9.6h-3.1v-8.8c0-2.9-1.1-5-4.3-5 c-3.1,0-4.5,2-4.5,4.8v9.1h-3.1V79.1z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M317.7,93.2l8.3-11.7h-8v-2.4h11.5v2.5l-8,11.4h8.2v2.4h-12V93.2z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M332.1,73.2h3.1v3.3h-3.1V73.2z M332.1,79.1h3.1v16.3h-3.1V79.1z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M341.4,88.2c0.1,3.3,3,5,5.5,5c2.2,0,3.8-1.1,4.7-2.8h3.2c-0.8,1.8-1.9,3.2-3.3,4c-1.4,0.9-3,1.4-4.7,1.4 c-5.3,0-8.6-4.3-8.6-8.6c0-4.7,3.7-8.7,8.6-8.7c2.3,0,4.5,0.9,6,2.4c1.9,2,2.7,4.5,2.5,7.2H341.4z M352.2,85.8 c-0.2-2.2-2.3-4.6-5.4-4.5c-3.2,0-5.2,2.3-5.4,4.5H352.2z"
  })), /*#__PURE__*/React.createElement("g", {
    className: "st1"
  }, /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M358.4,79.1h2.9v2.4c0.9-1.9,2.6-2.8,4.9-2.9v3.1h-0.2c-2.9,0-4.5,1.6-4.5,4.9v8.8h-3.1V79.1z"
  })), /*#__PURE__*/React.createElement("g", {
    className: "st1"
  }, /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M370.3,81.5h-2.9v-2.4h2.9v-5.9h3.1v5.9h3.2v2.4h-3.2v13.9h-3.1V81.5z"
  })), /*#__PURE__*/React.createElement("g", {
    className: "st1"
  }, /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M380.1,88.2c0.2,3.3,3,5,5.5,5c2.2,0,3.8-1.1,4.7-2.8h3.2c-0.8,1.8-1.9,3.2-3.3,4c-1.4,0.9-3,1.4-4.6,1.4 c-5.3,0-8.6-4.3-8.6-8.6c0-4.7,3.7-8.7,8.6-8.7c2.3,0,4.5,0.9,6,2.4c1.9,2,2.7,4.5,2.5,7.2H380.1z M391,85.8 c-0.1-2.2-2.3-4.6-5.4-4.5c-3.2,0-5.2,2.3-5.4,4.5H391z"
  })), /*#__PURE__*/React.createElement("g", {
    className: "st1"
  }, /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M79.5,131.4h-3.8l9.1-22.2H88l9,22.2h-3.8l-2.1-5.2h-9.5L79.5,131.4z M86.3,113.3l-3.8,10h7.6L86.3,113.3z "
  }), /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M115.8,129.5c0,2.8-0.7,4.7-1.9,6.1c-1.5,1.7-4,3-6.9,3c-4.6,0-7.3-2.7-8.1-5.4h3.6c0.4,0.7,1,1.4,1.8,1.9 c1,0.7,2.1,0.9,2.8,0.9c2.7,0,5.5-2,5.5-5.7v-1.7c-1,1.8-2.9,3.4-5.9,3.4c-4.9,0-8.4-3.7-8.4-8.6c0-5.1,3.7-8.7,8.4-8.7 c2.7,0,5,1.4,5.9,3.2v-2.8h3.1V129.5z M101.4,123.2c0,3.1,2.2,5.7,5.6,5.7c1.6,0,3-0.6,4-1.7c1-1,1.6-2.4,1.6-4 c0-1.3-0.4-2.8-1.3-3.9c-0.9-1.1-2.3-1.9-4.3-1.9C104,117.5,101.4,119.9,101.4,123.2L101.4,123.2z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M121.8,124.2c0.1,3.3,3,5,5.5,5c2.2,0,3.8-1.1,4.7-2.8h3.2c-0.8,1.8-1.9,3.2-3.3,4c-1.4,0.9-3,1.4-4.6,1.4 c-5.3,0-8.6-4.3-8.6-8.6c0-4.7,3.7-8.7,8.6-8.7c2.3,0,4.5,0.9,6,2.4c1.9,2,2.7,4.5,2.5,7.2H121.8z M132.7,121.8 c-0.1-2.2-2.3-4.6-5.4-4.5c-3.2,0-5.2,2.3-5.4,4.5H132.7z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M138.8,115.1h2.9v2.5c0.8-1.7,2.6-3,5.5-3c5.2,0.1,6.6,3.8,6.6,7.2v9.6h-3.1v-8.8c0-2.9-1.1-5-4.3-5 c-3.1,0-4.5,2-4.5,4.8v9.1h-3.1V115.1z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M159.1,117.5h-2.9v-2.4h2.9v-5.9h3.1v5.9h3.1v2.4h-3.1v13.9h-3.1V117.5z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M182.7,131.4h-2.9v-2.5c-0.8,1.7-2.6,3-5.5,3c-5.2,0-6.6-3.8-6.6-7.2v-9.6h3.1v8.9c0,2.9,1.1,5,4.3,5 c3.1,0,4.5-2,4.5-4.8v-9.1h3.1V131.4z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M186.8,115.1h2.9v2.4c0.9-1.9,2.6-2.8,4.9-2.9v3.1h-0.2c-2.9,0-4.5,1.6-4.5,4.9v8.8h-3.1V115.1z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M205.7,109.2h3.1v3.3h-3.1V109.2z M205.7,115.1h3.1v16.3h-3.1V115.1z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M212.9,115.1h2.9v2.5c0.8-1.7,2.6-3,5.5-3c5.2,0.1,6.6,3.8,6.6,7.2v9.6h-3.1v-8.8c0-2.9-1.1-5-4.3-5 c-3.1,0-4.5,2-4.5,4.8v9.1h-3.1V115.1z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M257.4,131.4h-3v-2.8c-0.9,1.7-2.7,3.3-6.1,3.3c-5.1,0-8.4-4-8.4-8.7c0-5.1,3.7-8.6,8.3-8.6 c3.3,0,5.4,1.9,6,3.1v-2.9v-5.7h3.1V131.4z M243,123.2c0,3,2.1,5.7,5.7,5.7c1.6,0,3.1-0.7,4.1-1.7c1-1,1.7-2.5,1.6-4.1 c0-1.6-0.6-3-1.6-4c-1-1-2.4-1.6-4-1.6C245.3,117.5,243,120.1,243,123.2L243,123.2z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M263.5,124.2c0.2,3.3,3,5,5.5,5c2.2,0,3.8-1.1,4.7-2.8h3.2c-0.8,1.8-1.9,3.2-3.3,4c-1.4,0.9-3,1.4-4.6,1.4 c-5.3,0-8.6-4.3-8.6-8.6c0-4.7,3.7-8.7,8.6-8.7c2.3,0,4.5,0.9,6,2.4c1.9,2,2.7,4.5,2.5,7.2H263.5z M274.4,121.8 c-0.1-2.2-2.3-4.6-5.4-4.5c-3.2,0-5.2,2.3-5.4,4.5H274.4z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M280.5,115.1h2.9v2.4c0.9-1.9,2.6-2.8,4.9-2.9v3.1h-0.2c-2.9,0-4.5,1.6-4.5,4.9v8.8h-3.1V115.1z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M301.5,124.2c0.1,3.3,3,5,5.5,5c2.2,0,3.8-1.1,4.7-2.8h3.2c-0.8,1.8-1.9,3.2-3.3,4c-1.4,0.9-3,1.4-4.7,1.4 c-5.3,0-8.6-4.3-8.6-8.6c0-4.7,3.7-8.7,8.6-8.7c2.3,0,4.5,0.9,6,2.4c1.9,2,2.7,4.5,2.5,7.2H301.5z M312.3,121.8 c-0.2-2.2-2.3-4.6-5.4-4.5c-3.2,0-5.2,2.3-5.4,4.5H312.3z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M318.5,115.1h2.9v2.4c0.9-1.9,2.6-2.8,4.9-2.9v3.1h-0.2c-2.9,0-4.5,1.6-4.5,4.9v8.8h-3.1V115.1z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M335.8,119.3c0-1.3-0.8-2.2-2.4-2.2c-1.5,0-2.4,1-2.3,2.1c0.1,1.3,1.2,1.9,3,2.4c2.5,0.7,5.2,1.4,5.3,4.9 c0.1,3.2-2.6,5.3-5.8,5.3c-2.6,0-5.8-1.5-5.9-5.2h3.1c0.1,2,1.7,2.6,2.9,2.6c1.5,0,2.7-1,2.7-2.4c0-1.6-1.3-2.2-4.2-3.1 c-2.3-0.7-4.1-1.8-4.1-4.2c0-3.1,2.5-4.9,5.5-4.9c2.2,0,5.2,1.1,5.4,4.7H335.8z"
  })), /*#__PURE__*/React.createElement("g", {
    className: "st1"
  }, /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M343.7,117.5h-2.9v-2.4h2.9v-5.9h3.1v5.9h3.2v2.4h-3.2v13.9h-3.1V117.5z"
  })), /*#__PURE__*/React.createElement("g", {
    className: "st1"
  }, /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M353.5,124.2c0.2,3.3,3,5,5.5,5c2.2,0,3.8-1.1,4.7-2.8h3.2c-0.8,1.8-1.9,3.2-3.3,4c-1.4,0.9-3,1.4-4.7,1.4 c-5.3,0-8.6-4.3-8.6-8.6c0-4.7,3.7-8.7,8.6-8.7c2.3,0,4.5,0.9,6,2.4c1.9,2,2.7,4.5,2.5,7.2H353.5z M364.4,121.8 c-0.1-2.2-2.3-4.6-5.4-4.5c-3.2,0-5.2,2.3-5.4,4.5H364.4z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M370.5,115.1h2.9v2.5c0.8-1.7,2.6-3,5.5-3c5.2,0.1,6.6,3.8,6.6,7.2v9.6h-3.1v-8.8c0-2.9-1.1-5-4.3-5 c-3.1,0-4.5,2-4.5,4.8v9.1h-3.1V115.1z"
  })), /*#__PURE__*/React.createElement("g", {
    className: "st1"
  }, /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M94.9,151.5c-0.6-0.8-1.3-1.5-2-2.1c-1.3-0.9-2.9-1.5-4.7-1.5c-4.2,0-8.1,3.2-8.1,8.3c0,5.3,4,8.5,8.1,8.5 c2,0,3.8-0.6,5.1-1.6c1.4-1,2.3-2.4,2.6-4h-9.6v-2.9h13.7c0,1.4-0.2,3.3-1,5c-2,4.4-6.6,6.6-10.8,6.6 c-6.6,0-11.7-5.1-11.7-11.6c0-6.6,5.2-11.5,11.7-11.5c4.8,0,9.1,2.9,10.6,6.7H94.9z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M105.1,160.2c0.1,3.3,3,5,5.5,5c2.2,0,3.8-1.1,4.7-2.8h3.2c-0.8,1.8-1.9,3.2-3.3,4c-1.4,0.9-3,1.4-4.6,1.4 c-5.3,0-8.6-4.3-8.6-8.6c0-4.7,3.7-8.7,8.6-8.7c2.3,0,4.5,0.9,6,2.4c1.9,2,2.7,4.5,2.5,7.2H105.1z M116,157.8 c-0.1-2.2-2.3-4.6-5.4-4.5c-3.2,0-5.2,2.3-5.4,4.5H116z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M122.1,151.1h2.9v2.5c0.8-1.7,2.6-3,5.5-3c5.2,0.1,6.6,3.8,6.6,7.2v9.6H134v-8.8c0-2.9-1.1-5-4.3-5 c-3.1,0-4.5,2-4.5,4.8v9.1h-3.1V151.1z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M143.2,160.2c0.1,3.3,3,5,5.5,5c2.2,0,3.8-1.1,4.7-2.8h3.2c-0.8,1.8-1.9,3.2-3.3,4c-1.4,0.9-3,1.4-4.6,1.4 c-5.3,0-8.6-4.3-8.6-8.6c0-4.7,3.7-8.7,8.6-8.7c2.3,0,4.5,0.9,6,2.4c1.9,2,2.7,4.5,2.5,7.2H143.2z M154.1,157.8 c-0.1-2.2-2.3-4.6-5.4-4.5c-3.2,0-5.2,2.3-5.4,4.5H154.1z"
  })), /*#__PURE__*/React.createElement("g", {
    className: "st1"
  }, /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M160.2,151.1h2.9v2.4c0.9-1.9,2.6-2.8,4.9-2.9v3.1h-0.2c-2.9,0-4.5,1.6-4.5,4.9v8.8h-3.1V151.1z"
  })), /*#__PURE__*/React.createElement("g", {
    className: "st1"
  }, /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M185.9,167.4h-3.1v-2.8c-1.1,2.2-3.5,3.3-6.1,3.3c-5.2,0-8.4-4.1-8.4-8.6c0-5,3.6-8.6,8.4-8.6 c3.2,0,5.3,1.8,6.1,3.4v-2.9h3.1V167.4z M171.5,159.3c0,2.4,1.7,5.7,5.7,5.7c2.5,0,4.3-1.4,5.1-3.2c0.4-0.8,0.5-1.6,0.6-2.4 c0-0.8-0.1-1.7-0.5-2.4c-0.8-1.9-2.6-3.4-5.2-3.4C173.7,153.5,171.5,156.2,171.5,159.3L171.5,159.3z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M191.2,153.5h-2.9v-2.4h2.9v-5.9h3.1v5.9h3.1v2.4h-3.1v13.9h-3.1V153.5z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M199.8,145.2h3.1v3.3h-3.1V145.2z M199.8,151.1h3.1v16.3h-3.1V151.1z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M206.1,159.2c0-4.3,3.2-8.6,8.7-8.6c5.5,0,8.7,4.3,8.7,8.6c0,4.4-3.2,8.6-8.7,8.6 C209.3,167.9,206.1,163.6,206.1,159.2L206.1,159.2z M209.2,159.3c0,3.2,2.5,5.7,5.6,5.7c3.1,0,5.6-2.4,5.6-5.7 c0-3.3-2.5-5.7-5.6-5.7C211.7,153.5,209.2,156,209.2,159.3L209.2,159.3z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M226.7,151.1h2.9v2.5c0.8-1.7,2.6-3,5.5-3c5.2,0.1,6.6,3.8,6.6,7.2v9.6h-3.2v-8.8c0-2.9-1.1-5-4.3-5 c-3.1,0-4.5,2-4.5,4.8v9.1h-3.1V151.1z"
  })), /*#__PURE__*/React.createElement("g", {
    className: "st1"
  }, /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M249.8,167.4h-3.3v-3.9h3.3V167.4z"
  }))))))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgElement84);
export default __webpack_public_path__ + "static/media/Element 84.a663ba0cb0401e0e5da64b92899dae28.svg";
export { ForwardRef as ReactComponent };